const HOME = 'Home';
const FOOTER = 'Footer';
const STANDINGS = 'Standings';
const PUBLICATION_INDEX = 'PublicationIndex';
const CONTENT_LICENSING = 'ContentLicensing';
const DOWNLOADS = 'Downloads';
const HEADSHOTS = 'Headshots';
const LOGOS = 'Logos';
const TEAM = 'Team';

export default {
    HOME,
    FOOTER,
    STANDINGS,
    PUBLICATION_INDEX,
    CONTENT_LICENSING,
    DOWNLOADS,
    HEADSHOTS,
    LOGOS,
    TEAM
};
